import React, { Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Box, Skeleton } from '@mui/material'

// Lazy load the TransactionDetail component
const LazyTransactionDetail = React.lazy(() =>
  import('@/modules/transactions/transaction-detail').then((module) => ({
    default: module.TransactionDetail,
  })),
)

// Loading fallback component
const TransactionDetailLoadingFallback = () => (
  <Box sx={{ padding: '2rem', width: '100%' }}>
    <Skeleton variant="rectangular" width={100} height={36} sx={{ mb: 3 }} />
    <Skeleton variant="rectangular" width="40%" height={40} sx={{ mb: 1 }} />
    <Skeleton variant="rectangular" width="20%" height={24} sx={{ mb: 4 }} />

    {[1, 2, 3, 4].map((section) => (
      <Box key={section} sx={{ mb: 4 }}>
        <Skeleton variant="rectangular" width="30%" height={28} sx={{ mb: 2 }} />
        <Box sx={{ pl: 2 }}>
          {[1, 2, 3].map((item) => (
            <Box key={item} sx={{ display: 'flex', mb: 2 }}>
              <Skeleton variant="rectangular" width="20%" height={24} sx={{ mr: 2 }} />
              <Skeleton variant="rectangular" width="40%" height={24} />
            </Box>
          ))}
        </Box>
      </Box>
    ))}
  </Box>
)

export const Route = createFileRoute(
  '/_public/_layout/transactions/$transaction',
)({
  component: () => (
    <Suspense fallback={<TransactionDetailLoadingFallback />}>
      <LazyTransactionDetail />
    </Suspense>
  ),
})
